import type { TitleProps } from './types'

import * as S from './styles'

export const Title = ({ label, action, marginTop = 32, marginBottom = 24, ...props }: TitleProps) => {
  return (
    <S.Container {...props}>
      <S.Label style={{ marginTop: marginTop as number, marginBottom: marginBottom as number }}>{label}</S.Label>

      {!!action && <S.Action>{action}</S.Action>}
    </S.Container>
  )
}
